import React from 'react';
import EmbeddedNotepadClusterNotesTab from 'shared_items/embeddedNotepad/EmbeddedNotepadClusterNotesTab';
import {
  getTravelEmbeddedNotepadCluster,
  patchTravelEmbeddedNotepadCluster,
} from '../moduleServices/travel_services';

const MainTravelNotes = () => (
  <EmbeddedNotepadClusterNotesTab
    layoutVariant="module-tab"
    containerClassName=""
    fabClassName="bg-gray-700 hover:bg-gray-800"
    fetchClusterLink={async () => {
      const res = await getTravelEmbeddedNotepadCluster();
      return res.data;
    }}
    patchClusterLink={async (clusterId) => {
      const res = await patchTravelEmbeddedNotepadCluster(
        clusterId != null ? Number(clusterId) : null,
      );
      return res.data;
    }}
  />
);

export default MainTravelNotes;
